/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const SwitchQuerySvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor">
    <path d="M12,2.828,21.172,12,12,21.172,2.828,12,12,2.828M12,0,0,12,12,24,24,12,12,0Z"/>
  </svg>
);

export const SwitchQueryIcon = (props) => <Icon component={SwitchQuerySvg} {...props} />;
